var map = {
	"./bet-tnc-cn.svg": 967,
	"./fifa-tnc-cn.svg": 968,
	"./leaderboard-tnc-cn.svg": 969,
	"./lucky-tnc-cn.svg": 970,
	"./term-condition-bm.svg": 971,
	"./term-condition-cn.svg": 972,
	"./term-condition-id.svg": 973,
	"./term-condition-vn.svg": 974,
	"./term-condition.svg": 975,
	"./term-content.png": 976,
	"./term-footer.png": 977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 966;